import useKakao from 'hooks/useKakao';
import { StatusProvider } from './contexts/statusContext';
import Router from './routes/Router';
import ThemeProvider from './theme';
import 'react-datepicker/dist/react-datepicker.css';
import useCommonData from './hooks/useCommonData';
import useSetting from './hooks/useSetting';

export default function App() {
    useKakao();
    useCommonData();
    useSetting();
    return (
        <StatusProvider>
            <ThemeProvider>
                <Router />
            </ThemeProvider>
        </StatusProvider>
    );
}
